import { __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';

var styles = {"component":"select__component_1ohn0","popoverInner":"select__popoverInner_1ohn0","optionsListWrapper":"select__optionsListWrapper_1ohn0","optionsListBorder":"select__optionsListBorder_1ohn0","nativeSelect":"select__nativeSelect_1ohn0","block":"select__block_1ohn0","emptySearchPlaceholder":"select__emptySearchPlaceholder_1ohn0","search":"select__search_1ohn0"};
require('./components/base-select/index.css');

var ListPopoverDesktop = function (props) {
    var Popover = props.Popover, open = props.open, popoverProps = props.popoverProps, fieldRef = props.fieldRef, _a = props.popoverPosition, popoverPosition = _a === void 0 ? 'bottom-start' : _a, _b = props.preventFlip, preventFlip = _b === void 0 ? true : _b, popperClassName = props.popperClassName, updatePopover = props.updatePopover, zIndexPopover = props.zIndexPopover, renderOptionsList = props.renderOptionsList;
    if (Popover) {
        return (React.createElement(Popover, __assign({}, popoverProps, { open: open, withTransition: false, anchorElement: fieldRef.current, position: popoverPosition, preventFlip: preventFlip, popperClassName: cn(styles.popoverInner, popperClassName), update: updatePopover, zIndex: zIndexPopover }), renderOptionsList()));
    }
    return null;
};

export { ListPopoverDesktop as L, styles as s };
